import React from 'react';
import cn from 'clsx';
import { ModalContent } from 'fronton-react';
import { css } from 'linaria';
import { List, ModalHeader, Typography } from 'common/components';

const convenientSolutionsModalText = css`
  margin-bottom: 8px;
`;

const convenientSolutionsModalList = css`
  margin-bottom: 40px;

  li:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const ConvenientSolutionsModal = () => (
  <>
    <ModalHeader title="Спроектируем шкаф, двери-купе или полноценную гардеробную под ваши индивидуальные размеры." />
    <ModalContent>
      <Typography className={convenientSolutionsModalText} variant="m" size="body_long">
        Проектирование доступно в&nbsp;магазинах:
      </Typography>
      <List className={cn(convenientSolutionsModalList, convenientSolutionsModalText)} listStyle="disc">
        <li>
          <Typography variant="m" size="body_long">
            Лемана ПРО Уральская
          </Typography>
          <Typography variant="m" size="body_long">
            г. Санкт-Петербург, ул. Уральская, 20А
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            Лемана ПРО Коллонтай
          </Typography>
          <Typography variant="m" size="body_long">
            г. Санкт-Петербург, ул. Коллонтай, д.&nbsp;3
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            Лемана ПРО Испытателей
          </Typography>
          <Typography variant="m" size="body_long">
            г. Санкт-Петербург, проспект Испытателей, д.&nbsp;5, корп.&nbsp;2, лит. А
          </Typography>
        </li>
        <li>
          <Typography variant="m" size="body_long">
            Лемана ПРО Парашютная
          </Typography>
          <Typography variant="m" size="body_long">
            г. Санкт-Петербург, ул.Парашютная, д. 60В
          </Typography>
        </li>
      </List>
    </ModalContent>
  </>
);
